// eslint-disable-next-line @typescript-eslint/no-var-requires
const Handlebars = require('handlebars/runtime');

Handlebars.registerHelper('equals', function (value, compareValue, options) {
  if (value === compareValue) {
    return options.fn(this);
  } else {
    return options.inverse(this);
  }
});

Handlebars.registerHelper('checkKeyword', function (value, keyword) {
  return value === keyword ? 'true' : 'false';
});
Handlebars.registerHelper('isActive', function (currentPage, pageNumber) {
  return currentPage === pageNumber ? 'active' : '';
});

module.exports = Handlebars;
